import React from "react";
import '../../App.css';

/**
 * This is shared between the regular booking site and the waitlist... so it's here for now.
 */
export const WhatIsKensuSection = () => {

  return <div className={'AppSection WhiteSection'}>
    <div className={'AppSectionContent WhatIsKensuSection'}>
      <div>
        <h2 className={'OrangeText'}>What is Kensu?</h2>
        <p className={'IntroCalloutText'}>
          At Kensu (健寿) - meaning health and longevity - we’ve built a platform that helps you navigate holistic and
          preventative care by connecting with vetted Eastern and Western wellness practitioners.
        </p>
        <p className={'IntroCalloutText'}>
          It’s never the wrong time to prioritize your health, and with Kensu, it’s easier than ever.
        </p>
      </div>
    </div>

  </div>
}